/**
 * Created by qlong on 9/12/2016.
 */
import React, {Component} from 'react';
import { connect } from 'react-redux'
import { onFileLoad } from '../actions/fileDataActions'
import SpaghettiData from '../SpaghettiData'
import { addFilterGridData, resetFilterGrid } from '../actions/filterGridAction'
import { setSelectedOption, clearFilters, addCategory } from '../actions/filterActions'
import { changeIndicator } from '../actions/filteredLineChartActions'
const vizJsonData = require('../../data/visualizationLibrary.json');
let csvs = {}
vizJsonData.visualizations.forEach((viz) => {
    csvs[viz.csv] = require('../../data/' + viz.csv)
})

@connect()
export default class File extends Component{
    loadFile(){
        const pathname = this.props.path
        const csvName = vizJsonData.visualizations.filter((viz) => (viz.routeName == pathname || pathname == ""))[0].csv

        let dataObj = new SpaghettiData(csvs[csvName]);
        let jsonData = dataObj.getData();
        let filters = dataObj.getFilters();
        //reset store
        this.props.dispatch(resetFilterGrid())
        this.props.dispatch(clearFilters())

        this.props.dispatch(onFileLoad({selected_filename: csvName, chartData:jsonData}))
        this.props.dispatch(addFilterGridData(filters))
        // Default shade to the first value
        this.props.dispatch(setSelectedOption(0))
        this.props.dispatch(changeIndicator(true))
    }

    shouldComponentUpdate(nextProps){
        return nextProps.path != this.props.path
    }

    componentDidMount (){
        this.loadFile()
    }

    componentDidUpdate (){
        this.loadFile()
    }

    render(){
        return(
            <div></div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/File.js
 **/